/* eslint-disable @next/next/no-img-element */
import { useState, forwardRef, Ref } from "react";

// components
import FloorPlanMark from "./FloorPlanMark";

// interfaces
import { ILocationSpaceItem } from "@/types/api/Locations";

// assets
import styles from "@/assets/styles/pages/location-single-page/location-single-page-components.module.scss";


interface ImageDimensions {
  height: number;
  width: number;
}

interface FloorPlanMapProps {
  spaces: ILocationSpaceItem[];
  floorPlanImage: string;
  onPinClick?: () => void;
}

const FloorPlanMap = (props: FloorPlanMapProps, ref: Ref<HTMLDivElement>) => {
  const { spaces, floorPlanImage, onPinClick } = props;

  const [imageDimensions, setImageDimensions] = useState<ImageDimensions | null>(null);

  return (
    <div
      className={styles["locl-location-floor-plan__map"]}
      data-testid="locl-location-floor-plan-map"
      ref={ref}
    >
      <img
        loading="lazy"
        data-testid="locl-location-floor-plan-image-map"
        className={styles["locl-location-floor-plan__image-map"]}
        src={floorPlanImage}
        alt="Floor plan"
        onLoad={(e: React.SyntheticEvent<HTMLImageElement, Event>) => setImageDimensions({
          height: (e.target as HTMLElement).offsetHeight,
          width: (e.target as HTMLElement).offsetWidth
        })}
      />
      {
        imageDimensions && (spaces || []).map((item, index) => (
          <FloorPlanMark
            coordinates={item.coordinates}
            spaceAssetType={item.spaceAssetType}
            key={`FloorPlanMark-${index}-${imageDimensions.width}`}
            parentWidth={imageDimensions.width}
            onPinClick={onPinClick}
          />
        ))
      }
    </div>
  );
};

FloorPlanMap.displayName = "FloorPlanMap";
export default forwardRef(FloorPlanMap);
